import { KeycloakService } from 'keycloak-angular';
import { environment } from "src/environments/environment";
/* You can get the code source example here > https://github.com/carbonrider/angular-examples/tree/main/keycloak-integration  */
export function initializeKeycloak(keycloak: KeycloakService): () => Promise<boolean> {
  return () =>
    keycloak.init({
      config: {
        url: environment.APP_KEYCLOAK_URL,
        realm: environment.APP_KEYCLOAK_REALM,
        clientId: environment.APP_KEYCLOAK_CLIENT_ID
      },
      initOptions: {
        onLoad: 'login-required',
        checkLoginIframe: false
        /*,checkLoginIframeInterval: 25*/
      },
      loadUserProfileAtStartUp: true
    });
}